export default __webpack_public_path__ + "static/media/rotate-pause.122db87d.svg";